export default {
    render() { },
    props: {
        props_order: {
            required: true
        }
    },
    data() {
        return {
            order: JSON.parse(this.props_order)
        }
    },
    mounted() {
        window.dataLayer = window.dataLayer || []
        dataLayer.push(this.first);
        dataLayer.push(this.second);
        dataLayer.push(this.third);
        dataLayer.push(this.purchase);
        fbq('track', 'Purchase', { currency: "UAH", value: this.order.fullCost }); // указываем сумму заказа
    },
    computed: {
        first() {
            let object = {
                'transactionId': this.order.order_id, // ID заказа
                'transactionAffiliation': 'Order at site',
                'transactionTotal': this.order.fullCost, // Сумма заказа (с учётом скидки)
                'transactionTax': 0,
                'transactionShipping': 0,
                'transactionProducts': []
            };

            this.order.products_array.forEach(element => {
                object.transactionProducts.push({
                    'sku': element.product.code, // Код товара (не артикул, а именно код)
                    'name': element.product.meta.title, // Название товара
                    'category': null, // Главная категория
                    'price': element.price, // цена товара (с учётом скидки)
                    'quantity': element.count // кол-во товара
                });
            });

            return object;
        },
        second() {
            let object = {
                'event': 'transaction',
                'ecommerce': {
                    'currencyCode': 'UAH', //Передаем код валюты
                    'purchase': {
                        'actionField': {
                            'id': this.order.order_id,   // ID заказа
                            'affiliation': 'Order at site', // Передаем "Order at site"
                            'revenue': this.order.fullCost  // Стоимость транзакции
                        },
                        'products': []
                    }
                }
            };

            this.order.products_array.forEach(element => {
                object.ecommerce.purchase.products.push({
                    'name': element.product.meta.title,//Передаем название товара
                    'id': element.product.code,  //Код товара
                    'price': element.price, //Передаем актуальную цену товара
                    'category': null,   //Передаем категорию товара. Категории поддерживают до 5 уровней вложенности. Каждый уровень отделяется разделителем "/". Например: Apparel/Mens/Shirts/Tshirts
                    'quantity': element.count //Передаем количество товара
                });
            });

            return object;
        },
        third() {

            let object = {
                'event': 'purchase',
                'value': this.order.fullCost, // сумма заказа
                'items': []
            };

            this.order.products_array.forEach(element => {
                object.items.push({
                    'id': element.product.code, // Передаём код (не ID)
                    'google_business_vertical': 'retail'
                });
            });

            return object;
        },

        purchase() {

            let object = {
                'event': 'purchase',
                'ecommerce': {
                    'transaction_id': this.order.order_id,
                    'value': this.order.fullCost,
                    'items': []
                }
            };

            this.order.products_array.forEach(element => {
                object.ecommerce.items.push({
                    'item_name': element.product.meta.title,
                    'item_id': element.product.code, // Передаём код (не ID)
                    'price': element.price,
                    'quantity': element.count,
                    'currency': "UAH"
                });
            });

            return object;
        }
    }
}
